/* global Vue, LOYALTY_AWARDS */

import AwardCardList from './components/AwardCardList'
import { messagesSpecific } from '../i18n/translations'
import { CreateI18n } from '../i18n/create-i18n'

const i18n = CreateI18n(messagesSpecific)

const AwardsListApp = Vue.createApp({
  components: { AwardCardList },
  template: '<AwardCardList :awards="LOYALTY_AWARDS" :useFilters="true" />',
  setup () {
    return {
      LOYALTY_AWARDS,
    }
  },
})

const appElement = document.getElementById('awards-list-app')

if (appElement) {
  AwardsListApp.use(i18n)
  AwardsListApp.mount(appElement)
}

export default AwardsListApp
